import { createAsyncThunk } from "@reduxjs/toolkit";

const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * fetch all Waitlist entries
 */
export const fetchWaitlistItems = createAsyncThunk(
  "waitlist/fetchItems",
  async () => {
    const res = await fetch(`${API_BASE}/api/waitlist`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY,
      },
    });
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

// Post wait list
export const postWaitlistItem = createAsyncThunk(
  "waitlist/postItem",
  async ({ email_address, id, created_at }, { rejectWithValue }) => {
    try {
      const response = await fetch(`${API_BASE}/api/waitlist`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": "GaGARmhsAq66QxSIyEys2JsXKufxYTpq",
        },
        body: JSON.stringify({ email_address, id, created_at }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Submission failed");
      }

      return data;
    } catch (error) {
      return rejectWithValue(error.message || "Network error");
    }
  }
);
